export const GATEWAY_URL = `${
  process.env.NEXT_PUBLIC_GATEWAY_URL || 'https://gateway.qmee.com'
}/graphql`;
export const GATEWAY_SUBSCRIPTION_URL = `${GATEWAY_URL.replace(/^http/, 'ws')}/ws`;
export const AUTHENTICATION_URL =
  process.env.NEXT_PUBLIC_AUTHENTICATION_URL || 'https://auth.qmee.com';
